import { render, staticRenderFns } from "./LastActivityItem.vue?vue&type=template&id=563bece0"
import script from "./LastActivityItem.vue?vue&type=script&lang=js"
export * from "./LastActivityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports